"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acuto": {
    "10734655": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "skipSearch": false
    }],
    "anagni": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb200ce6": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "skipSearch": false
    }],
    "ferentino": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5266ee9e": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "skipSearch": false
    }],
    "fiuggi": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c5ec21c": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "skipSearch": false
    }],
    "piglio": [{
      "hkey": "c0c705de",
      "slug": "acuto",
      "name": "Acuto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;